import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';

export const GraphContainerBox = withStyles(
  ({ palette, spacing, breakpoints }: Theme) => ({
    root: {
      paddingBottom: spacing(2),
      marginBottom: spacing(2),
      borderBottom: `1px solid ${palette.grey[200]}`,
      [breakpoints.up('sm')]: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'flex-end',
      },
    },
  })
)((props: BoxProps) => {
  return <Box {...props} />;
});

export const InfoBox = withStyles(
  ({ palette, spacing, breakpoints }: Theme) => ({
    root: {
      borderLeft: `1px solid ${palette.grey[200]}`,
      width: 'calc(100% / 2)',
      padding: spacing(0, 2),
      boxSizing: 'border-box',
      marginBottom: spacing(2),
      [breakpoints.up('sm')]: {
        width: 'calc(100% / 3)',
      },
    },
  })
)((props: BoxProps) => {
  return <Box {...props} />;
});

export const Caption = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))((props: TypographyAllProps) => <FsBodySmall component="h5" {...props} />);

export const Value = withStyles({})((props: TypographyAllProps) => (
  <FsBodySmallBold {...props} />
));
